<div class="d-flex flx-grow-1 flex-row person-list-item">
  <div *ngIf="isGuest" class="mr-2 p-1">
    <span class="ic-new-person"></span>
  </div>
  <div class="flex-grow-1 person-list-column" *ngIf="!isGuest">
    <div class="flex-grow-1 d-flex flex-row p-1">
      <div class="m-1">
        <div
          class=" person-initials rounded-circle color-gray-bg white avatar d-flex justify-content-center flex-shrink-0">
          <div class="align-self-center white">
            {{userName | initials}}
          </div>
        </div>
      </div>
      <div class="d-flex flex-grow-1 flex-column ml-2 font-weight-bold">
        <div class="flex-grow-1">{{userName}}</div>
        <div class="flex-grow-1">ID: {{person.memberId}}</div>
      </div>
    </div>
  </div>
  <div class="flex-grow-1 d-flex flex-column  person-list-column">
    <div class="flex-grow-1">
      {{person.phoneNumber | phoneMask}}
    </div>
    <div class="flex-grow-1">
      {{person.eMail}}
    </div>
  </div>
  <div *ngIf="showRemoveButton">
    <span class="ic-remove" (click)="onRemoveClick()"></span>
  </div>
</div>
